import { useRouter } from 'next/router';
import { withTheme } from 'styled-components';
import { useRecoilValue } from 'recoil';
import { pageFlow, positionStart, windowSize } from '@/recoil/atoms';
import { getPageAnimationVariants } from '@/helpers';
import Accent from '@/components/typography/Accent';
import Paragraph from '@/components/typography/Paragraph';
import Title from '@/components/typography/Title';
import CloseIcon from '@/components/icons/Close';
import SkillsSection from './SkillsSection';

import { SSkillsSet, SHeader, SIntro } from './styles';

const SkillsSet = () => {
  const router = useRouter();
  const screenSize = useRecoilValue(windowSize);
  const boundingClientRect = useRecoilValue(positionStart);
  const flow = useRecoilValue(pageFlow);
  const { origin } = flow;

  const handleClose = () => {
    router.push('/');
  };

  return (
    <SSkillsSet
      data-testid="skills-set"
      initial="start"
      animate="end"
      exit="exit"
      variants={getPageAnimationVariants(flow, screenSize, boundingClientRect)}
      transition={{ duration: 0.1 }}
    >
      <SHeader>
        <CloseIcon
          alt={`Back to ${origin ? origin : 'home'}`}
          handleClose={handleClose}
        />
        <Title>Skills Set</Title>
      </SHeader>
      <SIntro data-testid="skills-set-intro">
        <Paragraph>
          <Accent>10 years of experience</Accent> as a front-end developer in
          web agencies and as a freelancer has enabled me to develop a
          transversal knowledge of the core front-end principles:
          <br />
          <Accent>HTML5, CSS3, JavaScript</Accent>, associated with a good eye
          for design, and an interest in User Experience.
        </Paragraph>
        <Paragraph>
          These competencies associated to{' '}
          <Accent>organizational skills</Accent> and the capacity to foresee
          bottle necks in developement enabled me to seemlessly transition to
          the role of <Accent>front-end lead</Accent>.
        </Paragraph>
      </SIntro>
      <SkillsSection />
    </SSkillsSet>
  );
};

export default withTheme(SkillsSet);
